// extracted by mini-css-extract-plugin
module.exports =  {"title":"rejectionReasonModal-module_title_d7cd9","text":"rejectionReasonModal-module_text_feccd","date":"rejectionReasonModal-module_date_ab899"};